import React from 'react';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import type { Theme } from '@material-ui/core';

const styles = (theme: Theme) => ({
    separator: {
        userSelect: 'none',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),

        '&:first-of-type': {
            marginLeft: 0,
            display: 'none',
        },
    },
});

interface CrumbProps {
    children: React.ReactNode;
}

export const Crumb: React.FC<CrumbProps> = ({ children }) => {
    const classes = useKlpStyles({}, styles);

    return (
        <>
            <span className={classes.separator}>/</span>
            {children}
        </>
    );
};
